import { faCreditCard, faBan, faPlay, faMoneyBill } from '@fortawesome/pro-regular-svg-icons';
import { faArrowRotateRight } from '@fortawesome/pro-solid-svg-icons';
import { MembershipItem } from '@spike/membership-model';

export type EnrollmentAction = 'update_card' | 'cancel' | 'collect_payment' | 'resume' | 'try_again';

export interface EnrollmentActionConfig {
    label: string;
    icon: any;
    action: EnrollmentAction;
}

export function getEnrollmentActions(status: string, enrollmentType: string): EnrollmentActionConfig[] {
    let actions: EnrollmentActionConfig[] = [];

    switch (status) {
        case 'active':
            actions = [
                { label: 'Update Card', icon: faCreditCard, action: 'update_card' },
                { label: 'Cancel', icon: faBan, action: 'cancel' }
            ];
            break;
        case 'pending':
            actions = [
                { label: 'Collect Payment', icon: faMoneyBill, action: 'collect_payment' },
                { label: 'Cancel', icon: faBan, action: 'cancel' }
            ];
            break;
        case 'paused':
            actions = [
                { label: 'Resume', icon: faPlay, action: 'resume' },
                { label: 'Cancel', icon: faBan, action: 'cancel' }
            ];
            break;
        case 'past_due':
            actions = [
                { label: 'Try Again', icon: faArrowRotateRight, action: 'try_again' },
                { label: 'Update Card', icon: faCreditCard, action: 'update_card' },
                { label: 'Cancel', icon: faBan, action: 'cancel' }
            ];
            break;
        default:
            actions = [];
    }

    // Filter out 'Update Card' action if enrollmentType is 'package'
    if (enrollmentType === 'package') {
        actions = actions.filter(action => action.action !== 'update_card');
    }

    return actions;
}

export function getEnrollmentStatusClass(status: string): string {
    switch (status.toLowerCase()) {
        case 'active':
            return 'badgeActive';
        case 'pending':
            return 'badgePending';
        case 'canceled':
            return 'badgeCanceled';
        case 'paused':
            return 'badgePaused';
        case 'past_due':
            return 'badgePastDue';
        default:
            return 'badgeActive';
    }
}

export function calculateUsage(item: MembershipItem): { used: number; total: string | number } {
    const used = item.unlimited ? 0 : Math.max(0, item.quantity - (item.left ?? 0));
    const total = item.unlimited ? 'Unlimited' : item.quantity;
    return { used, total };
}
